import { UserScope } from "interfaces";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useStores } from "stores";
import { useWebSocketNotifications } from "utils/hooks/useWebSocketNotifications";
import { usePendingStatistics } from "utils/hooks/usePendingIndicators";
import { routes } from "constants/routes";

interface Props {
  render: (props: { isAuthenticated: boolean; roles: (roles: UserScope[]) => boolean }) => React.ReactNode;
}

export const AuthenticationGuard = observer(({ render }: Props) => {
  const { user } = useStores();
  const userId = user.userInfo?.id;

  useWebSocketNotifications(userId);
  usePendingStatistics(userId);

  React.useEffect(() => {
    user.init();
  }, [user]);

  if (user.status === "fetching" || user.status === "init") {
    return null;
  }

  if (!user.isAuthorized && !user.isAfterLogout && window.location.pathname.replace(/\//g, "") !== routes.login) {
    user.setRedirectPathname(window.location.pathname);
  }

  return (
    <>
      {render({
        isAuthenticated: user.isAuthorized,
        roles: (roles: UserScope[]) => user.scope.some((role) => roles.includes(role)),
      })}
    </>
  );
});
